// Одиниці виміру: назви з ПН (як у lib/pn/model.js UNITS) і цифрові коди одиниць митниці (у специфікації МД).
// Регістр, пробіли й крапка в кінці не важать; «посл.» = «послуга». Невідомий код митниці лишається видимим
// («код МД 999»), а не вгадується
const UNIT_SYN = { посл: "послуга" };
export const CUSTOMS_UNITS = { 796: "шт", 798: "тис.шт", 166: "кг", 168: "т", 6: "м", 55: "м2", 113: "м3", 112: "л",
  704: "набір", 715: "пар", 736: "рул", 778: "уп", 839: "компл" };
export function normUnit(u) {
  const t = String(u ?? "").trim().toLowerCase().replace(/\.$/, "");
  if (/^\d{1,3}$/.test(t)) return CUSTOMS_UNITS[Number(t)] || `код МД ${Number(t)}`;
  return UNIT_SYN[t] || t;
}
